import ApplicationController from "./application_controller"
import flatpickr from "flatpickr"

import "flatpickr/dist/flatpickr.min.css"

export default class extends ApplicationController {
  static targets = ["input"]

  connect() {
    this.initializeFlatpickr()
  }

  disconnect() {
    if (this.picker) {
      this.picker.destroy()
    }
  }

  initializeFlatpickr() {
    const enableTime =
      this.data.get("enableTime") === "true"

    const enableDate =
      this.data.get("enableDate") !== "false"

    const mode =
      this.data.get("mode") || "single"

    const minDate =
      this.data.get("minDate") || null

    const maxDate =
      this.data.get("maxDate") || null

    const showMonths =
      parseInt(this.data.get("showMonths"), 10) || 1

    const altFormat =
      this.data.get("altFormat") ||
      (enableTime
        ? "F j, Y h:i K"
        : "F j, Y")

    const dateFormat =
      this.data.get("dateFormat") ||
      (enableTime
        ? "Y-m-d H:i"
        : "Y-m-d")

    // Range mode's default needs an array of dates; the data attribute is always
    // a plain string, so split it on our own "start - end" convention.
    const rawDefaultDate = this.data.get("defaultDate") || null
    const defaultDate =
      mode === "range" && rawDefaultDate
        ? rawDefaultDate.split(" - ").filter(Boolean)
        : rawDefaultDate

    // TEMP DEBUG -- remove once the range picker is confirmed working.
    console.log("🚀 flatpickr connecting", { element: this.element, mode, showMonths, defaultDate, maxDate })

    this.picker = flatpickr(this.element, {
      wrap: true,
      allowInput: false, // selection-only via the calendar UI, no manual typing
      disableMobile: true,

      monthSelectorType: "dropdown",

      enableTime: enableTime,
      noCalendar: !enableDate,
      time_24hr: false,

      altInput: true,
      altFormat: altFormat,
      dateFormat: dateFormat,

      mode: mode,
      showMonths: showMonths,
      defaultDate: defaultDate,
      minDate: minDate,
      maxDate: maxDate,

      prevArrow:
        '<i class="fa-solid fa-chevron-left"></i>',

      nextArrow:
        '<i class="fa-solid fa-chevron-right"></i>',

      onReady: (_, __, instance) => {
        instance.calendarContainer.classList.add(
          "gv-flatpickr-theme"
        )

        // No selection + maxDate:"today" would default to [current, next], leaving a
        // disabled future month visible. jumpToDate anchors to [previous..current]
        // instead, without selecting anything. See docs Section 9.
        if (showMonths > 1 && !defaultDate) {
          const anchor = new Date()
          anchor.setDate(1)
          anchor.setMonth(anchor.getMonth() - (showMonths - 1))
          instance.jumpToDate(anchor, false)
        }

        // TEMP DEBUG -- remove once the range picker is confirmed working.
        console.log("✅ flatpickr ready", instance)
      },

      onChange: (selectedDates, dateStr) => {
        // TEMP DEBUG -- remove once the range picker is confirmed working.
        console.log("📅 flatpickr onChange", { selectedDates, dateStr })
      },

      onClose: (selectedDates, dateStr, instance) => {
        // TEMP DEBUG -- remove once the range picker is confirmed working.
        console.log("📅 flatpickr onClose", { selectedDates, dateStr })

        if (mode === "range" && selectedDates.length !== 2) return

        const formatted = selectedDates
          .map((date) => instance.formatDate(date, dateFormat))
          .join(" - ")

        this.dispatch("change", { detail: { selectedDates, dateStr, formatted } })
      }
    })
  }

  clear() {
    this.picker?.clear()
  }

  open() {
    console.log("🖱️ flatpickr#open called", this.picker)
    this.picker?.open()
  }

  close() {
    this.picker?.close()
  }
}